var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row ma-0"},[_c('p',{staticClass:"mr-10"},[_vm._v(_vm._s(_vm.getTitle(_vm.cell)))]),_c('p',[_vm._v(_vm._s(_vm.getValueFromReferenceKey(_vm.cell.referenceKey)))])])}
var staticRenderFns = []

export { render, staticRenderFns }